// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const WifiError = createIcon(
  <path
    clipRule="evenodd"
    d="M6.97332 4.86616C6.62186 4.51468 6.05201 4.51466 5.70053 4.86613C5.34905 5.21759 5.34904 5.78744 5.7005 6.13892L6.73033 7.1688C5.52249 7.69161 4.37561 8.39975 3.33295 9.29321C2.89293 9.67027 2.89478 10.3388 3.30453 10.7485L11.1869 18.6309C11.5967 19.0406 12.261 19.0406 12.6707 18.6309L15.4314 15.8702L16.805 17.2439C17.1565 17.5954 17.7263 17.5954 18.0778 17.2439C18.4293 16.8925 18.4293 16.3226 18.0778 15.9712L6.97332 4.86616ZM20.6955 10.6061L17.8363 13.4654L10.524 6.15276C14.0702 5.74145 17.7486 6.73744 20.6546 9.1406C21.1062 9.51408 21.1099 10.1917 20.6955 10.6061Z"
    fillRule="evenodd"
  />,
);
